import React, { FC } from 'react';

import { MilestoneDateIcon, milestoneDateIconDefaultProps, MilestoneDateIconProps } from './MilestoneDateIcon';
import { ENTITY_COLORIZATION }                                                      from "@src/constants";

const customStartDateIconDefaultProps: MilestoneDateIconProps = {
	...milestoneDateIconDefaultProps,
}

const CustomMilestoneIcon: FC<MilestoneDateIconProps> = ( props ) => {

	return (

		<MilestoneDateIcon
			{ ...props }
			icon={ {
				...( props.icon ?? {} ),
				color: ENTITY_COLORIZATION.MILESTONES.CUSTOM,
				style: { transform: 'scale(1.2) rotate(45deg)' }
			} }
		/>
	);
};

CustomMilestoneIcon.defaultProps = customStartDateIconDefaultProps;

export { CustomMilestoneIcon }
